<!-- activity.component.html -->
<div *ngIf="saved" class="print-history-popup">
    <div class="print-history-popup-body">
      <h2 class="popup-title">
        <!-- Saved successfully -->
        {{'appointments.gui.labels.Saved Successfully' | translate}}
    </h2>
      <button
        (click)="saved = false"
        class="print-history-popup-close"
        aria-label="close popup"
      ></button>
    </div>
  </div>
  <div *ngIf="showDeleteAlert" class="print-history-popup">
    <div class="print-history-popup-body">
      <h2 class="popup-title">
        {{'appointments.gui.labels.alert delete' | translate}}
    </h2>
    <button class="orange-btn" (click)="deleteRoom(ls.room)">     {{'appointments.gui.buttons.delete room' | translate}}</button>
      <button
        class="print-history-popup-close"
        (click)="showDeleteAlert = false"
        aria-label="close popup"
      ></button>
    </div>
  </div>
  <div *ngIf="editRoom" class="print-history-popup">
    <div class="print-history-popup-body">
      <h2 class="popup-title">
        {{'appointments.gui.buttons.change room name' | translate}}
    </h2>
    <div class="l-flex l-flex-c t-field t-field-pad" style="margin: 5%;width: 90%;">
      <input type="text" class="t-field-text w100" [(ngModel)]="selectedRoom.RoomName"  placeholder="change name"/>
    </div>
    <div class="l-flex l-flex-c t-field t-field-pad" style="margin: 5%;width: 90%; gap: 1em;">
      <label style="white-space: nowrap;">{{ 'appointments.gui.labels.room type' | translate }}</label>
      <label class="t-label-top py-4">
        <input type="radio" class="custom-check" [(ngModel)]="selectedRoom.roomType" value="exam" />
        <i class="customInput-display" style="border:1px solid;"></i>
        <span>{{ 'appointments.gui.labels.exam room' | translate }}</span>
      </label>
      <label class="t-label-top py-4">
        <input type="radio" class="custom-check" [(ngModel)]="selectedRoom.roomType" value="doctor" />
        <i class="customInput-display" style="border:1px solid;"></i>
        <span>{{ 'appointments.gui.labels.doctor room' | translate }}</span>
      </label>
    </div>
    <div class="l-flex l-flex-c t-field t-field-pad" style="margin: 5%;width: 90%; gap: 1em;">
      <label style="white-space: nowrap;">{{ 'appointments.gui.labels.room schedule type' | translate }}</label>
      <label class="t-label-top py-4">
        <input type="radio" class="custom-check" [(ngModel)]="selectedRoom.isOneTime" [value]="false" />
        <i class="customInput-display" style="border:1px solid;"></i>
        <span>{{ 'appointments.gui.labels.permanent room' | translate }}</span>
      </label>
      <label class="t-label-top py-4">
        <input type="radio" class="custom-check" [(ngModel)]="selectedRoom.isOneTime" [value]="true" />
        <i class="customInput-display" style="border:1px solid;"></i>
        <span>{{ 'appointments.gui.labels.one-time room' | translate }}</span>
      </label>
    </div>
    <div *ngIf="selectedRoom.isOneTime" class="l-flex l-flex-c t-field t-field-pad" style="margin: 5%;width: 90%; gap: 1em;">
      <label style="white-space: nowrap;">{{ 'appointments.gui.labels.Start date' | translate }}</label>
      <input type="date" class="t-field-text w100"
        [value]="formatDateForInput(selectedRoom.oneTimeDate)" (change)="selectedRoom.oneTimeDate = $event.target.value" />
    </div>
    <div *ngIf="selectedRoom.isOneTime" class="l-flex l-flex-c t-field t-field-pad" style="margin: 5%;width: 90%; gap: 1em;">
      <label style="white-space: nowrap;">{{ 'appointments.gui.labels.End date' | translate }}</label>
      <input type="date" class="t-field-text w100"
        [value]="formatDateForInput(selectedRoom.oneTimeDateTo)" (change)="selectedRoom.oneTimeDateTo = $event.target.value" />
    </div>
    <div *ngIf="selectedRoom.isOneTime" class="l-flex l-flex-c t-field t-field-pad" style="margin: 5%;width: 90%; gap: 1em;">
      <label style="white-space: nowrap;">{{ 'billing.gui.labels.Exam Name' | translate }}</label>
      <select class="t-select w100" [(ngModel)]="selectedRoom.oneTimeExamType">
        <option [ngValue]="null" disabled>--</option>
        <option *ngFor="let exam of exams" [value]="exam.AutoIndex">
          {{ getExamName(exam) }}
        </option>
      </select>
    </div>
    <div *ngIf="dateRangeError" style="color:#c0392b; margin: 0 5% 0.5em; text-align:right;">{{ dateRangeError }}</div>
    <button class="orange-btn" (click)="updateRoomName()">     {{'appointments.gui.buttons.Save' | translate}}</button>
      <button
        class="print-history-popup-close"
        (click)="editRoom = false"
        aria-label="close popup"
      ></button>
    </div>
  </div>
  <app-rooms *ngIf="addRoom" (closed)="addRoom=false"></app-rooms>
<div class="wrapper">
    <div class="m-box">
        <h2>
            <!-- Activity Hours -->
            {{'appointments.gui.labels.Activity Hours' | translate}}
        </h2>
        <div style="display: flex;flex-direction: row;justify-content: space-between; margin-bottom: 1.5em;">
          <div>
        <button class="orange-btn" [matTooltip]="'appointments.gui.tooltips.Save Changes' | translate" (click)="showDeleteAlert=true">
            {{'appointments.gui.buttons.delete room' | translate | titlecase}}
        </button>
        <button class="blue-btn" (click)="getRoomName(ls.room);editRoom=true" >
          {{'appointments.gui.labels.edit room' | translate}}
      </button>
    </div>
        <button class="blue-btn" (click)="addRoom=true" >
            {{'appointments.gui.buttons.add room' | translate}}
        </button>
       </div>
        <div class="flex-rox-space"
            *ngFor="let day of daysToShow">
                <h3 class="w5 rtl">
                    {{'appointments.gui.Days.'+day | translate | titlecase }}
                    <span *ngIf="currentRoom?.isOneTime" style="display:block; font-size: 0.8em; color:#277382;">
                      {{ getDateForDay(day) }}
                    </span>
                </h3>
            <div style="display: flex; flex-direction: column; gap: 1em;">



                <div *ngFor="let hour of activityHours[day]; let i = index" >
                    <ng-container *ngIf="hour.status !== 'delete'">
                      <div class="l-flex l-flex-w patient-details temp-activity"  *ngIf="activityHours[day][i].hasTempActivity">
                      
                        <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                          <label class="w50" style="white-space: nowrap;"> {{ 'billing.gui.labels.Exam Name' | translate}}</label>
                          <select class="t-select w100" [(ngModel)]="activityHours[day][i].temp.examType" (change)="markAsUpdated(day, i)">
                            <option *ngFor="let exam of getExamTypes()" [value]="exam.AutoIndex">
                              {{ getExamName(exam) }}
                            </option>
                          </select>
                        </div>
                        <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                          <label class="w50" style="white-space: nowrap;">
                            {{ 'appointments.gui.labels.End date' | translate }}
                          </label>
                          <input type="date" style="white-space: nowrap;" class="t-field-text w100"
                            [value]="formatDate(activityHours[day][i].temp.endTime)" (change)="updateTempDate(day, i, 'endTime', $event)">
                        </div>
                        <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                          <label class="w50" style="white-space: nowrap;">
                            {{ 'appointments.gui.labels.Start date' | translate }}
                          </label>
                          <input type="date" style="white-space: nowrap;" class="t-field-text w100"
                            [value]="formatDate(activityHours[day][i].temp.startTime)" (change)="updateTempDate(day, i, 'startTime', $event)">
                        </div>
                      </div>
                      <div style="display: flex;gap: 1em;">
                        <div class="l-flex l-flex-w t-fieldmargin patient-details" >
                            <div class="flex flex-wrap items-center w50" (dblclick)="activityHours[day][i].includeInRoomSearch=false;markAsUpdated(day, i)">
                      
                              <div class="flex flex-wrap lgw-5_6 xlw-11_12">
                                  
                                  <label class="t-label-top py-4">
                                      <input type="radio" class="custom-check"  [name]="day + '-' + i" [(ngModel)]="activityHours[day][i].includeInRoomSearch" (change)="markAsUpdated(day, i)"   [value]="true"/>
                                      <i class="customInput-display"></i>
                                      <span>
                                        {{ 'appointments.gui.labels.include in search' | translate}}
                                      </span>
                                  </label>
                              </div>
                            </div>
                            <div class="flex flex-wrap items-center w50" (dblclick)="activityHours[day][i].hasTempActivity=false;markAsUpdated(day, i)">
                      
                              <div class="flex flex-wrap lgw-5_6 xlw-11_12">
                                  
                                  <label class="t-label-top py-4">
                                      <input type="radio" class="custom-check"  [name]="day + '-' + i" [(ngModel)]="activityHours[day][i].hasTempActivity" (change)="markAsUpdated(day, i)"   [value]="true"/>
                                      <i class="customInput-display"></i>
                                      <span>
                                        {{ 'appointments.gui.labels.change purpose' | translate | titlecase }}
                                      </span>
                                  </label>
                              </div>
                            </div>
                            
                       
                            
                          </div>
                        <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                            <label class="w50" style="white-space: nowrap;">   {{ 'billing.gui.labels.Exam Name' | translate}}</label>
                            <ng-container *ngIf="currentRoom?.isOneTime; else examSelect">
                              <span class="t-select w100" style="display:flex; align-items:center; padding: 0 0.5em; overflow:hidden; white-space:nowrap; text-overflow:ellipsis; cursor:default; opacity:0.7;">{{ getOneTimeExamName() }}</span>
                            </ng-container>
                            <ng-template #examSelect>
                              <select class="t-select w100"  [(ngModel)]="activityHours[day][i].examType" (change)="markAsUpdated(day, i)" >
                                <option *ngFor="let exam of getExamTypes()" [value]="exam.AutoIndex">
                                  {{ getExamName(exam) }}
                                </option>
                              </select>
                            </ng-template>
                        </div>
                    <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                        <label class="w50" style="white-space: nowrap;">{{ 'appointments.gui.labels.End Hour' | translate}} </label>
                        <input type="time" style="white-space: nowrap;" class="t-field-text w100"
                            [(ngModel)]="activityHours[day][i].endTime" (change)="markAsUpdated(day, i)">
                    </div>
                    <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                        <label class="w50" style="white-space: nowrap;">{{ 'appointments.gui.labels.Start Hour' | translate}} </label>
                        <input type="time" style="white-space: nowrap;" class="t-field-text w100"
                            [(ngModel)]="activityHours[day][i].startTime" (change)="markAsUpdated(day, i)">
                    </div>
                    <img class="delete-hour"  [matTooltip]="'appointments.gui.tooltips.Delete Hour' | translate" (click)="deleteHour(day,i)" src="../../assets/icons/minus-blue.svg" />
                  </div>
                  </ng-container>
                </div>
                <hr style="width: 100%; opacity: 0.3;">
            </div>
            <div  style="display: flex;
            justify-content: flex-end;
            align-items: end;"  >

                <img class="add-hour" [matTooltip]="'appointments.gui.tooltips.Add Hour' | translate" (click)="addHour(day)" src="../../assets/icons/plus-orange.svg" />
            </div>

        </div>
        
        <button class="blue-btn" (click)="saveActivityHours()" >
            <!-- save  -->
            {{'appointments.gui.buttons.Save' | translate}}
        </button>
    </div>
</div>